// To be used on both tipsheet content and cards
import { Link } from 'react-router-dom';

// Fallback base_url if hostInfo is not available
const DEFAULT_BASE_URL = 'https://calmatters.digitaldemocracy.org';

// Module-level variable to store the dynamic base_url
let _base_url = DEFAULT_BASE_URL;

// Function to set base_url from DD_DOMAIN
// DD_DOMAIN is always just the domain (e.g., "civilbeat.digitaldemocracy.org")
// so we always prepend "https://"
export const setBaseUrlFromDDDomain = (ddDomain) => {
  if (ddDomain) {
    // Always add https:// protocol since DD_DOMAIN is always just the domain
    _base_url = `https://${ddDomain}`;
  } else {
    _base_url = DEFAULT_BASE_URL;
  }
};

// Export base_url as a getter function
export const getBaseUrl = () => _base_url;
const default_target = '_blank';
const entity_types = {
  leg: 'legislators',
  org: 'organizations',
  hea: 'hearings',
  per: 'people',
  bil: 'bills',
  com: 'committees',
  fin: 'financials',
  alt: '',
  other: '',
};

function __LinkDD(
  inText,
  inUrl,
  inKey = null,
  returnText = true,
  hrefOnly = false
) {
  if (inUrl && hrefOnly) {
    return inUrl;
  }
  if (inText === null || inUrl === null) {
    return null;
  }
  let newKey = inKey;
  if (inKey === null) {
    newKey = Date.now();
  }
  if (returnText) {
    return `<a href= ${inUrl} target=${default_target} key=${newKey}>${inText}</a>`;
  }

  return (
    <Link to={inUrl} key={newKey} target={default_target}>
      {inText}
    </Link>
  );
}

export function LinkSimple(inText, inUrl, inKey = null, returnText = true) {
  return __LinkDD(inText, inUrl, inKey, returnText);
}

export function LinkDD(
  inText,
  id,
  inType,
  inKey = null,
  returnText = true,
  altText = null,
  suffix = '',
  hrefOnly = false
) {
  // Use the dynamic base_url from the module-level variable
  let url = getBaseUrl();
  if (id && !isNaN(+id)) id = id.toString();

  if (inType !== null) {
    switch (inType) {
      case 'leg':    // use only for direct link to a current legislator page if you must otherwise, use 'per' because it should
                     // redirect to the current status page of a legislator even if they have left office by the viewing time
        url +=
          '/' +
          entity_types[inType] +
          '/' +
          inText.toLowerCase().split(' ').join('-') +
          '-' +
          id;
        break;
      case 'hea':
        url += '/' + entity_types[inType] + '/' + id + suffix;
        break;
      case 'other':
        break;
      default:
        url += '/' + entity_types[inType] + '/' + id;
        break;
    }
    if (altText) return __LinkDD(altText, url, inKey, returnText);
    return __LinkDD(inText, url, inKey, returnText, hrefOnly);
  }
}
